import * as api from 'services/api';
import { addError } from 'actions/error';

export const getCompanySponsorship =
  (id, query = '') =>
  (dispatch) =>
    api
      .get(`companies/by-profession/${id}${query}`, 'GET_COMPANY_INFO', dispatch)
      .catch((error) => {
        dispatch(addError(new Error('GET_COMPANY_INFO_ERROR')));
        // Resolve with null on failure so a missing sponsor doesn't leak an
        // Error object into component state.
        return null;
      });

export const getCompanyInfo =
  (id, query = '') =>
  (dispatch) =>
    api.get(`companies/${id}`, 'GET_COMPANY_INFO', dispatch).catch((error) => {
      dispatch(addError(new Error('GET_COMPANY_INFO_ERROR')));
      // Resolve with null on failure so callers get a checkable value.
      return null;
    });
